import { render, staticRenderFns } from "./resumen-preguntas-ml-preguntas.vue?vue&type=template&id=8d25045e&scoped=true&"
import script from "./resumen-preguntas-ml-preguntas.vue?vue&type=script&lang=ts&"
export * from "./resumen-preguntas-ml-preguntas.vue?vue&type=script&lang=ts&"
import style0 from "./resumen-preguntas-ml-preguntas.vue?vue&type=style&index=0&id=8d25045e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d25045e",
  null
  
)

export default component.exports